"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconPadlock', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M9 9C9 8.44772 8.55228 8 8 8C7.44772 8 7 8.44772 7 9L7 11C7 11.5523 7.44772 12 8 12C8.55228 12 9 11.5523 9 11L9 9Z', 'M2 6C2 5.44772 2.44771 5 3 5H5L5 4C5 2.34315 6.34315 1 8 1C9.65685 1 11 2.34315 11 4V5H13C13.5523 5 14 5.44772 14 6L14 14C14 14.5523 13.5523 15 13 15H3C2.44772 15 2 14.5523 2 14L2 6ZM9 4V5L7 5V4C7 3.44772 7.44772 3 8 3C8.55228 3 9 3.44772 9 4ZM4 7L4 13H12V7H4Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M11 12C11 11.4477 10.5523 11 10 11C9.44772 11 9 11.4477 9 12L9 14C9 14.5523 9.44771 15 10 15C10.5523 15 11 14.5523 11 14L11 12Z', 'M3 8C3 7.44772 3.44771 7 4 7L6 7L6 5C6 2.79086 7.79086 1 10 1C12.2091 1 14 2.79086 14 5L14 7L16 7C16.5523 7 17 7.44772 17 8L17 18C17 18.5523 16.5523 19 16 19H4C3.44771 19 3 18.5523 3 18L3 8ZM12 7L8 7L8 5C8 3.89543 8.89543 3 10 3C11.1046 3 12 3.89543 12 5V7ZM5 9L5 17H15V9L5 9Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M13 14C13 13.4477 12.5523 13 12 13C11.4477 13 11 13.4477 11 14L11 17.0001C11 17.5524 11.4477 18.0001 12 18.0001C12.5523 18.0001 13 17.5524 13 17.0001V14Z', 'M2.99988 9C2.99988 8.44772 3.44759 8 3.99988 8H6.99988L6.99988 6C6.99988 3.23858 9.23845 1 11.9999 1C14.7613 1 16.9999 3.23858 16.9999 6V8L19.9999 8C20.5522 8 20.9999 8.44772 20.9999 9L20.9999 22C20.9999 22.5523 20.5522 23 19.9999 23H3.99988C3.44759 23 2.99988 22.5523 2.99988 22L2.99988 9ZM14.9999 8H8.99988L8.99988 6C8.99988 4.34315 10.343 3 11.9999 3C13.6567 3 14.9999 4.34315 14.9999 6V8ZM4.99988 10V21H18.9999V10L4.99988 10Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M17.5 18.5C17.5 17.6716 16.8284 17 16 17C15.1716 17 14.5 17.6716 14.5 18.5L14.5 22.5C14.5 23.3284 15.1716 24 16 24C16.8284 24 17.5 23.3284 17.5 22.5L17.5 18.5Z', 'M3 11.5C3 10.6716 3.67157 10 4.5 10H9V8C9 4.13401 12.134 1 16 1C19.866 1 23 4.13401 23 8V10H27.5C28.3284 10 29 10.6716 29 11.5L29 29.5C29 30.3284 28.3284 31 27.5 31L4.5 31C3.67157 31 3 30.3284 3 29.5L3 11.5ZM20 10L12 10V8C12 5.79086 13.7909 4 16 4C18.2091 4 20 5.79086 20 8V10ZM6 13L6 28H26V13H6Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;